import { PPLUS_CLIENT_ID, PPLUS_CLIENT_SECRET } from 'core-lib/data/common';

export const getHeaders = () => {
  return {
    'client-id': PPLUS_CLIENT_ID,
    'client-secret': PPLUS_CLIENT_SECRET,
  };
};
